import React, { Component, Fragment } from "react";
import {withRouter} from 'react-router';
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components';
import { fetchDeal } from "store/state/deal";
import Button from "@material-ui/core/Button";
import {Forward, ArrowDownward} from '@material-ui/icons';
import _ from "lodash";
import PropertyProjectionDashboard from "./PropertyProjectionDashboard";
import { fetchPropertiesWithprojections, clearProjections } from "store/state/property";
import TopForm from './TopForm';

const styles = {
    root: {
        background: "#333333"
    },
  };

  const BackButton = styled(Button)`
  && {
    margin-top: -3px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    float: right;
    margin-right: 50px;
  }
  &&:hover {
    background: #f6f6f6;
  }
  
`;

const PageContainer = styled.div`
    padding-left: 50px;
    min-width: 1250px;
`;



const SectionTitle = styled.p`
    font-size: 16pt;
    color: #999999;
    width: 100%;
    margin-bottom: 4px;
    padding-right: 0px;
`;

const PageTitle = styled.p`
    font-size: 17pt;
`;

const PageDescription = styled.p`
    font-size: 12pt;
`;

const BlueArrow = styled(Forward)`
    margin-bottom: -5px;
    color: #2196f3;
`;

const GreyBar = styled.div`
  background-color: #dddddd;
  color: #777777;
  border-radius: 3px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 50px;
  width: 70%;
`;

const FancyDivider = styled.hr`
margin-top: 50px;
margin-bottom: 50px;

`;
const GreenArrow = styled(ArrowDownward)`
    margin-bottom: -10px;
    color: #4cd964;
`;

export class ProjectionsPage extends Component {
    
    state = {
        dealId : -1,
    };

    componentDidMount(){
        this.setState({dealId: this.props.match.params.dealId});
        this.props.fetchDeal(this.props.match.params.dealId);
        this.props.fetchPropertiesWithprojections({dealId:this.props.match.params.dealId});
    }

    componentWillUnmount(){
        this.props.clearProjections();
    }


    didProjectionsChange = (prevProps) => {
        return false;
    }
    

    renderPropertyDashboards = () => {
        const state = this.state;
        if(this.props.deal && this.props.deal && this.props.deal.properties && this.props.deal.properties.length>0){
            const output = [];
            this.props.deal.properties = _.sortBy(this.props.deal.properties, "id");
            for(let i = 0; i < this.props.deal.properties.length; i++){
                let property = this.props.deal.properties[i];
                let projections = property.propertyProjections || null;
                output.push(<PropertyProjectionDashboard 
                    property={property}
                    projections={projections}
                    isPipeline={this.props.match.params.isPipeline==="true"}
                    targetedClosing={this.props.deal.targetedClosing ? new Date(this.props.deal.targetedClosing.split("T")[0]) : new Date()}
                    refreshProjections={()=>{this.props.fetchPropertiesWithprojections({dealId:this.props.match.params.dealId})}}
                    dealId={ this.state.dealId }
                    dealName={ this.props.deal.name }
                    history = {this.props.history}
                    />);
            }
            return output
        }else{
            return <GreyBar>No properties on this deal</GreyBar>
        }
    }

    render(){
        if(!this.props.match.params.dealId) return null;

        if(!this.hasProjectionAccess()){
            this.props.history.push("/accessDenied");
        }
        return( 
        <PageContainer>
            <BackButton onClick={this.props.history.goBack}>
                <span>Go Back</span>
              </BackButton>
            <PageTitle >{`Projections - ${this.props.deal ? this.props.deal.name : ""}`}</PageTitle>
            <TopForm dealId={this.props.match.params.dealId} />
            <FancyDivider/>
            <SectionTitle >{`Properties`}</SectionTitle>
            <PageDescription onClick={()=>this.forceUpdate()}>
                All values reflect end of period. Saving properties to Auto-calculate will re-calculate and create projections with your preference entries each month until preferences are changed.
                <br/>
                Use the <BlueArrow /> button to fill all cells to the right based on your data input.
                <br/>
                <GreenArrow/> Indicates the period relative to the Date of Action.
                </PageDescription>
            {this.renderPropertyDashboards()}
        </PageContainer >);
    }

    hasProjectionAccess = () => {
        if(this.props.authentication.isGuest){
            if(this.props.match.params.isPipeline==="true"){
                return this.props.activeGuest.pipelineProjections === undefined || this.props.activeGuest.pipelineProjections;
            } else {
                return this.props.activeGuest.portfolioProjections === undefined || this.props.activeGuest.portfolioProjections;
            }
        } else {
            return true;
        }
    }
}

const mapStateToProps = ({ authentication, deal, property, guest}) => ({
    authentication,
    deal: property.deal,
    propertyAssumptionToken: deal.propertyAssumptionToken,
    propertyProjections : property.propertyProjections,
    activeGuest: guest.activeGuest,
  });
  
  export default compose(
    withRouter,
    connect(mapStateToProps,{
        fetchDeal,
        fetchPropertiesWithprojections,
        clearProjections,
    }),
    withStyles(styles),
  )(ProjectionsPage);